import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractComponent, Channel, ChannelService } from 'lib-trend-core';
import { takeUntil } from 'rxjs';

type TabId = | 'dash' | 'config' | 'auto' | 'response' | 'template' | 'mod' | 'dep' | 'webhook' | 'api' | 'copilot';

@Component({
    selector: 'channel-view-component',
    // templateUrl: 'channel-view.component.html',
    templateUrl: 'channel-view.v2.component.html',
    styleUrls: ['./channel-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChannelViewComponent extends AbstractComponent implements OnInit {

  channel: Channel = undefined;

  activeTab: TabId = 'dash';

  constructor(
    public injector: Injector,
    private channelService: ChannelService,
  ) {
    super(injector);
  }

  ngOnInit() {
    const id = super.getParam('idChannel');
    if (!!id) {
      this.channelService.getById(id)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (channel) => {
            this.channel = channel;
          },
          error: (err) => this.alertService.error(err.error.message)
        });
    }
  }

  activate(tab: TabId): void {
    this.activeTab = tab;
  }

}
